import { z } from 'zod';
import { ResourceLibraryNewProductIntroductionBaseItem } from '../types/resourceLibraryItems';
import { GetResourceLibraryNewProductIntroductionItemListingSchema } from '../schemas/resourceLibraryNewProductIntroductionItemZodSchemas';
import { hydrateResourceLibraryNewProductIntroductionBaseItem } from './transformResourceLibraryNewProductIntroductionItemResponse';

/**
 * Transforms and validates the response from the getResourceLibraryNewProductIntroductionItemListing GraphQL query
 * to a simplified ResourceLibraryNewProductIntroductionBaseItem[] type.
 */
export function transformResourceLibraryNewProductIntroductionItemsResponse(
    data: unknown
): ResourceLibraryNewProductIntroductionBaseItem[] {
    const parsedResult = GetResourceLibraryNewProductIntroductionItemListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getResourceLibraryNewProductIntroductionItemListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const edges = parsedResult.data.getResourceLibraryNewProductIntroductionItemListing.edges;

    return edges.map(({ node }) => {
        const item = node as z.infer<
            typeof GetResourceLibraryNewProductIntroductionItemListingSchema
        >['getResourceLibraryNewProductIntroductionItemListing']['edges'][number]['node'];

        return hydrateResourceLibraryNewProductIntroductionBaseItem(item);
    });
}
